// Phase 5 (web revival) — Stream D.
//
// Four buttons for the four legal rotation values. Anything other than
// 0° pushes a `{ op: 'rotate', deg }` into the ops array; 0° removes the
// rotate op so the wire payload stays minimal (and matches what the
// renderer expects — passing `deg: 0` is a no-op but still a wire byte).

type Deg = 0 | 90 | 180 | 270;

interface RotateControlProps {
  value: Deg;
  onChange: (deg: Deg) => void;
}

const OPTIONS: Deg[] = [0, 90, 180, 270];

export function RotateControl({ value, onChange }: RotateControlProps) {
  return (
    <div>
      <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-neutral-400">
        Rotate
      </h3>
      <div className="grid grid-cols-4 gap-1.5">
        {OPTIONS.map((deg) => {
          const active = value === deg;
          return (
            <button
              key={deg}
              type="button"
              onClick={() => onChange(deg)}
              className={[
                'rounded-md border px-2 py-1.5 text-xs font-medium transition-colors',
                active
                  ? 'border-neutral-200 bg-neutral-200 text-neutral-900'
                  : 'border-neutral-800 bg-neutral-950 text-neutral-300 hover:bg-neutral-800',
              ].join(' ')}
            >
              {deg}°
            </button>
          );
        })}
      </div>
    </div>
  );
}
